module.exports = __webpack_public_path__ + "static/mobile-25b49a18cbc85c5add92844aad052943.png";